import { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import InputComponent from "../InputComponent";
import ButtonComponent from "../ButtonComponent";
import { FormattedMessage, useIntl } from "react-intl";
import Toast from "../../helpers/Toast";

type Props = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (data: {
    acceptanceMode: string;
    observations: string;
    rejectionMotive?: string;
  }) => void;
  isRejection?: boolean;
};

export default function DecisionModal({ isOpen, toggle, onSubmit, isRejection }: Props) {
  const intl = useIntl()
  const [acceptanceMode, setAcceptanceMode] = useState<string>("");
  const [otherAcceptanceMode, setOtherAcceptanceMode] = useState<string>("");
  const [observations, setObservations] = useState<string>("");
  const [rejectionMotive, setRejectionMotive] = useState<string>("");

  const handleConfirm = () => {
    const finalAcceptanceMode = acceptanceMode === "Outro" ? otherAcceptanceMode : acceptanceMode;

    //Verificar se não foi preenchido o campo do modo de aceitação
    if(!finalAcceptanceMode ){
        Toast.Show('error',intl.formatMessage({ id: "Screens.QuotationModal.Error.MissingAcceptanceMode" })); 
        return;
    }

    //Verificar se não foi preenchido o campo do motivo de rejeição
    if (isRejection && !rejectionMotive) {
        Toast.Show('error',intl.formatMessage({ id: "Screens.QuotationModal.Error.MissingRejectionReason" })); 
        return;
    }
    onSubmit({acceptanceMode: finalAcceptanceMode, observations, rejectionMotive });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <FormattedMessage id={isRejection
            ? "Screens.QuotationModal.RejectProposal"
            : "Screens.QuotationModal.AcceptProposal"} />
        </ModalHeader>
        <ModalBody>
            <div style={{ marginBottom: "10px" }}>
            <span className="label">
             <FormattedMessage id="Screens.QuotationModal.AcceptanceMode" />
            </span>

            <div>
                <label style={{ marginRight: "15px" }}>
                <input
                    type="radio"
                    name="modoAceitacao"
                    value="Telemovel"
                    checked={acceptanceMode === "Telemovel"}
                    onChange={(e) => setAcceptanceMode(e.target.value)}
                />{" "}
                 <FormattedMessage id="Screens.QuotationModal.AcceptanceMode.Phone" />
                </label>

                <label style={{ marginRight: "15px" }}>
                <input
                    type="radio"
                    name="modoAceitacao"
                    value="Email"
                    checked={acceptanceMode === "Email"}
                    onChange={(e) => setAcceptanceMode(e.target.value)}
                />{" "}
                 <FormattedMessage id="Screens.QuotationModal.AcceptanceMode.Email" />
                </label>

                <label style={{ marginRight: "15px" }}>
                <input
                    type="radio"
                    name="modoAceitacao"
                    value="Outro"
                    checked={acceptanceMode === "Outro"}
                    onChange={(e) => setAcceptanceMode(e.target.value)}
                />
                <span style={{ paddingLeft: "5px" }}>
                <FormattedMessage id="Screens.QuotationModal.AcceptanceMode.Other" />
                </span>
                </label>
            </div>
            </div>
        {acceptanceMode === "Outro" && (
        <InputComponent
            xl={4}
            lg={4}
            md={8}
            sm={10}
            xs={10}
            style={{ width: "100%", marginTop: "10px" }}
            type={"text"}
            value={otherAcceptanceMode}
            label={intl.formatMessage({
                id: "Screens.QuotationModal.AcceptanceMode.SpecifyOther",
              })}
            onChange={(e:string) => setOtherAcceptanceMode(e)}
        />
        )}
        <InputComponent xl={8} lg={8} md={10} sm={12} xs={12}
         style={{ width: "100%" }}
          type={"text"}
          value={observations}
          label={intl.formatMessage({
            id: "Screens.QuotationModal.Observations",
          })}
          onChange={(e:string) => setObservations(e)}
        />
        {isRejection && (
          <InputComponent xl={8} lg={8} md={10} sm={12} xs={12}
          style={{ width: "100%" }}
            type={"text"}
            value={rejectionMotive}
            label={intl.formatMessage({
                id: "Screens.QuotationModal.RejectionReason",
              })}
            onChange={(e:string) => setRejectionMotive(e)}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <ButtonComponent text={intl.formatMessage({
                id: "Screens.QuotationModal.Cancel",
              })} onClick={toggle} />
        <ButtonComponent text={intl.formatMessage({
                id: "Screens.QuotationModal.Confirm",
              })} onClick={handleConfirm} />
      </ModalFooter>
    </Modal>
  );
}